module.exports = "/_next/static/images/H-a34b75a98daccc75d371781f1916b4aa.png";